import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./ReduxToolkit/Store";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import "./i18n";
import { unstable_batchedUpdates } from "react-dom";
import { Component } from "react";
import AuthInitializer from "./Components/AuthInitializer";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";


import api, { setupInterceptors } from "./api/axios";
import { logout } from "./ReduxToolkit/Reducers/Layout/AuthReducer";

interface Props {
  children: React.ReactNode;
}
unstable_batchedUpdates(() => {
  console.error = () => {};
});

class ErrorBoundary extends Component<Props> {
  componentDidCatch(error: { message: string | string[] }) {
    if (error.message.includes("ToastContainer")) {
      return;
    }
  }
  render() {
    return this.props.children;
  }
}

const queryClient = new QueryClient();

setupInterceptors(store.dispatch, logout);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <AuthInitializer>
          <App />
        </AuthInitializer>
      </Provider>
    </QueryClientProvider>
  </ErrorBoundary>,
);
reportWebVitals();
